import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/comment-dots': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M144 208c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zM256 208c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zM368 208c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zM256 32c141.4 0 256 93.1 256 208s-114.6 208-256 208c-32.8 0-64-5.2-92.9-14.3-29.1 20.6-77.6 46.3-139.1 46.3-9.6 0-18.3-5.7-22.1-14.5-3.8-8.8-2-19 4.6-26 0.5-0.4 31.5-33.8 46.4-73.2-33-35.1-52.9-78.7-52.9-126.3 0-114.9 114.6-208 256-208zM256 400c114.7 0 208-71.8 208-160s-93.3-160-208-160-208 71.8-208 160c0 42.2 21.7 74.1 39.8 93.4l20.6 21.8-10.6 28.1c-5.5 14.5-12.6 28.1-19.9 40.2 23.6-7.6 43.2-18.9 57.5-29l19.5-13.8 22.7 7.2c25.3 8 51.7 12.1 78.4 12.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/comment-dots.js
// module id = 1716
// module chunks = 0